//表达式公共资源

//默认语言
export const DefaultLanguage = "zh-CHS";

/**
 * 函数前缀，用于打开时去除函数前缀（比如"DefaultFunction"）
 * @date 2022-05-13
 */
export const FunctionPrefixs = [
  "DefaultFunction", "Math"
]

/**
 * 一些函数由于命名不规范而弃用，这些函数重命名。为了支持已经保存的表达式，不规范命名函数将会保留，但是会被过滤掉
 * @date 2022-05-13
 */
export const DeprecatedFunctions = [
  "StringSubstring", "StringLength", "StringReplace", "StringToUpper", "StringToLower", "StringIndexOf", "StringLastIndexOf", "StringTrimStart", "StringTrimEnd", "StringTrim", "StringAdd",
  "Round", "BankerRound",
  "getComputeJsonData",
  "ToDecimal", "ToSingle"
]

/**
 * 表达式内置上下文变量：当前语言编号，当前用户Id，当前用户Code，当前用户Name，当前组织Id，当前组织Code，当前组织Name
 * @date 2022-05-13
 */
export const ContextVariables = {
  "zh-CHS": [
    {
      key: "CurrentSysOrgName",
      name: "当前组织Name",
      description: "当前组织Name"
    },
    {
      key: "CurrentSysOrgCode",
      name: "当前组织Code",
      description: "当前组织Code"
    },

    {
      key: "CurrentSysOrgId",
      name: "当前组织Id",
      description: "当前组织Id"
    },
    {
      key: "CurrentUserName",
      name: "当前用户Name",
      description: "当前用户Name"
    },
    {
      key: "CurrentUserCode",
      name: "当前用户Code",
      description: "当前用户Code"
    },
    {
      key: "CurrentUserId",
      name: "当前用户Id",
      description: "当前用户Id"
    },
    {
      key: "CurrentLanguage",
      name: "当前语言编号",
      description: "当前登录的语言编号，例如简体中文返回'zh-CHS'，英文返回'en'，繁体中文'zh-CHT'"
    }
  ],
  "en": [
    {
      key: "CurrentSysOrgName",
      name: "Current Organization Name",
      description: "Current Organization Name"
    },
    {
      key: "CurrentSysOrgCode",
      name: "Current Organization Code",
      description: "Current Organization Code"
    },
    {
      key: "CurrentSysOrgId",
      name: "Current Organization Id",
      description: "Current Organization Id"
    },
    {
      key: "CurrentUserName",
      name: "Current User Name",
      description: "Current User Name"
    },
    {
      key: "CurrentUserCode",
      name: "Current User Code",
      description: "Current User Code"
    },
    {
      key: "CurrentUserId",
      name: "Current User Id",
      description: "Current User Id"
    },
    {
      key: "CurrentLanguage",
      name: "Current Language",
      description: "The current login language code, for example, Simplified Chinese returns 'zh-CHS', English returns 'en', Traditional Chinese returns 'zh-CHT'"
    }
  ],
  "zh-CHT": [
    {
      key: "CurrentSysOrgName",
      name: "當前組織Name",
      description: "當前組織Name"
    },
    {
      key: "CurrentSysOrgCode",
      name: "當前組織Code",
      description: "當前組織Code"
    },
    {
      key: "CurrentSysOrgId",
      name: "當前組織Id",
      description: "當前組織Id"
    },
    {
      key: "CurrentUserName",
      name: "當前用戶Name",
      description: "當前用戶Name"
    },
    {
      key: "CurrentUserCode",
      name: "當前用戶Code",
      description: "當前用戶Code"
    },
    {
      key: "CurrentUserId",
      name: "當前用戶Id",
      description: "當前用戶Id"
    },
    {
      key: "CurrentLanguage",
      name: "當前語言編號",
      description: "當前登入的語言編號，例如簡體中文返回'zh-CHS'，英文返回'en'，繁體中文'zh-CHT'"
    }
  ]
}